import NewTripBill from "./NewTripBill";

export default NewTripBill;
